"use client";

import { useEffect, useRef, useState } from "react";

/**
 * Request below-the-fold ads only as users approach their slot.
 * The AdSense loader stays global; this hook NEVER simulates a click,
 * route change, or refresh of an existing ad.
 */
export function useNearViewportAd(enabled: boolean, eager = false) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [ready, setReady] = useState(eager);

  useEffect(() => {
    if (!enabled || ready) return;
    const target = containerRef.current;
    if (!target) return;

    if (!("IntersectionObserver" in window)) {
      setReady(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setReady(true);
          observer.disconnect();
        }
      },
      { rootMargin: "350px 0px 350px 0px", threshold: 0 }
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [enabled, ready]);

  return { containerRef, ready: enabled && ready };
}
